import React from 'react';
import { Link } from 'react-router-dom';
import classes from './GarageContent.module.scss';
import placeholderImage from '../../media/images/emptyFavorites.png';
import { carFromSnapshot } from '../../services/dealerGarage';
import { priceForCar, formatUsd } from '../../services/dealerStock';
import { buildVehicleSlug, buildVehicleTitle } from '../../helper/vehicleTitle';

// The stored snapshot's canonical www URL, or the portal's own detail page.
// The portal page is preferred when we can build it: it keeps the member
// inside the app and the heart/inquiry actions live there. A car won at
// auction has its page on the auction side of the portal.
const portalUrlFor = (car) => (car.source === 'auction'
    ? `/detail/${car._id}`
    : `/dealer-stock/${buildVehicleSlug(car)}/${car._id}`);

// Dealer-stock mileage is stored in thousands of km; current-inventory and
// auction cars carry the full figure.
const mileageText = (car) => {
    if (!car.mileage) return null;
    if (car.source === 'dealer-stock') return `${car.mileage}k km`;
    const km = Number(car.mileage);
    return `${Number.isFinite(km) ? km.toLocaleString('en-US') : car.mileage} km`;
};

/**
 * Compact vehicle strip shared by the inquiry, inspection and purchase cards.
 *
 * `listing` shows the live listing price and the "No longer listed" tag. A
 * purchase turns it off: the agreed price is what matters there, and a car the
 * member bought is of course no longer listed.
 */
const VehicleStrip = ({ record, listing = true }) => {
    const car = carFromSnapshot(record);
    const hasVehicle = !!(record.vehicleId && (car.make || car.model || car.title));
    const title = hasVehicle ? buildVehicleTitle(car) : 'General inquiry';
    const image = car.imageURLs[0] || placeholderImage;
    // 'duplicate': the same car is still listed under the copy the scraper kept.
    const sold = listing && car.status && !['active', 'available', 'incoming', 'reserved', 'duplicate'].includes(String(car.status).toLowerCase());

    const body = (
        <>
            <img
                src={image}
                alt={title}
                loading="lazy"
                onError={(e) => { e.target.onerror = null; e.target.src = placeholderImage; }}
            />
            <div className={classes.vehicleText}>
                <strong>{title}</strong>
                {hasVehicle && (
                    <span>
                        {[car.year, mileageText(car), car.color]
                            .filter(Boolean).join(' · ')}
                    </span>
                )}
                {hasVehicle && listing && (
                    <span className={classes.vehiclePrice}>{formatUsd(priceForCar(car))}</span>
                )}
                {sold && <span className={classes.soldTag}>No longer listed</span>}
            </div>
        </>
    );

    return hasVehicle
        ? <Link to={portalUrlFor(car)} className={classes.vehicle}>{body}</Link>
        : <div className={classes.vehicle}>{body}</div>;
};

export default VehicleStrip;
